export default __webpack_public_path__ + "static/media/TV.f25a4563.png";